import React from 'react'
import styles from './SettingsCard.module.scss'
import Grid from '@material-ui/core/Grid'
import { H6 } from '../../../../components/UI'
import { ReactComponent as Language } from '../../../../assets/svgs/farsi_language.svg'
import { ReactComponent as Currency } from '../../../../assets/svgs/rial_coin.svg'
import { ReactComponent as Timezone } from '../../../../assets/svgs/time_zone.svg'
import { ReactComponent as DollarCoin } from '../../../../assets/svgs/dollar_coin.svg'
import { ReactComponent as EuroCoin } from '../../../../assets/svgs/euro_coin.svg'
import { ReactComponent as EnglishLanguage } from '../../../../assets/svgs/english_language.svg'

const SettingsCard = (props) => {
	const icons = {
		fa: <Language with={24} height={24}/>,
		Rial: <Currency with={24} height={24}/>,
		Timezone: <Timezone with={24} height={24}/>,
		Dollar: <DollarCoin with={24} height={24}/>,
		EuroCoin: <EuroCoin with={24} height={24}/>,
		en: <EnglishLanguage with={24} height={24}/>
	}
	return (
		<div className={styles.root} style={props.style}>
			<Grid container justify={'space-around'} className={styles.headerCard}>
				<Grid item xs={6} md={6} spacing={1} className={styles.headerRightCard}>
					<p>{props.title}</p>
				</Grid>
				<Grid item xs={6} md={6}>
					<div className={styles.headerLeftCard}>
						<div className={styles.icon}>
							{icons[props.category]}
						</div>
						<span className={styles.strong}>{props.value}</span>
					</div>
				</Grid>
			</Grid>
			<Grid className={styles.description}>
				<p className={styles.H6}>{props.description}</p>
			</Grid>

		</div>
	)

}

export default SettingsCard
